import React from "react";

import {
  FiPackage,
  FiTruck,
  FiCheckCircle,
  FiClock,
  FiDownload,
} from "react-icons/fi";
import { CiMap } from "react-icons/ci";
import { useLocation } from "react-router-dom";
import jsPDF from "jspdf";
import { CiCalendar } from "react-icons/ci";
import PageTitle from "../store/PageTitle";

const MyOrder = () => {
  const StoresUrl = [
    {
      "City Gamers Kwazi RD":
        "https://www.google.com/maps/place/City+Gamers+and+electronics+world+(town)/@-15.4190192,28.2804414,17z/data=!3m1!4b1!4m6!3m5!1s0x1940f387ffebbd7d:0xc49594828f4c759d!8m2!3d-15.4190192!4d28.2804414!16s%2Fg%2F11vkfbwjpl?entry=ttu&g_ep=EgoyMDI1MDUwNi4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
    },
    {
      "City Gamers Novela Mall":
        "https://www.google.com/maps/place/Novare+Great+North+Mall/@-15.3619126,28.2780447,17z/data=!3m1!4b1!4m6!3m5!1s0x1940f53d4bda9f13:0x3956a271229ae3d6!8m2!3d-15.3619126!4d28.2780447!16s%2Fg%2F11g8nmswbq?entry=ttu&g_ep=EgoyMDI1MDUwNi4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
    },
    {
      "City Gamers Arcades Mall":
        "https://www.google.com/maps/place/City+Gamers+And+electronics+world+(arcades+branch)/@-15.3926598,28.3159936,17z/data=!3m1!4b1!4m6!3m5!1s0x19408b006a665f29:0xe77d1c4bb239d894!8m2!3d-15.3926598!4d28.3159936!16s%2Fg%2F11ybh2h71j?entry=ttu&g_ep=EgoyMDI1MDUwNi4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
    },
  ];
  const location = useLocation();
  const { order, orderItems } = location.state || {};
  console.log("order img", orderItems.item_img);
  console.log("my orders", order);
  console.log("my order items", orderItems);

  const getStatusIcon = (status) => {
    switch (status) {
      case "pending":
        return <FiClock className="status-icon yellow" />;
      case "In Transit":
        return <FiTruck className="status-icon blue" />;
      case "delivered":
        return <FiCheckCircle className="status-icon green" />;
      default:
        return <FiPackage className="status-icon gray" />;
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return "Invalid date";

    if (typeof timestamp === "string") {
      // Convert string date to JavaScript Date object
      return new Date(timestamp).toLocaleString();
    } else if (typeof timestamp === "object" && timestamp.seconds) {
      // Firebase timestamp case
      return new Date(timestamp.seconds * 1000).toLocaleString();
    } else {
      return "Unknown format";
    }
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    let yPos = 20;

    // Styled header
    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(40, 40, 40);
    doc.text("CITY GAMERS & ELECTRONIC WORLD", 105, yPos, { align: "center" });

    yPos += 15;

    // Decorative line
    doc.setDrawColor(200, 200, 200);
    doc.line(10, yPos, 200, yPos);
    yPos += 10;

    // Order details
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(80, 80, 80);

    const details = [
      `Order ID: ${order.id}`,
      `Date: ${formatDate(order.order_date)}`,
      `Status: ${order.order_status}`,
      `Payment: ${order.payment_status}`,
    ];

    details.forEach((text) => {
      doc.text(text, 15, yPos);
      yPos += 8;
    });

    yPos += 10;

    // Items header
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(40, 40, 40);
    doc.text("ITEMS:", 15, yPos);
    yPos += 10;

    // Items list
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    orderItems.forEach((item, index) => {
      doc.setTextColor(60, 60, 60);
      doc.text(`- ${item.item_name}`, 20, yPos);

      doc.setTextColor(100, 100, 100);
      doc.text(`Quantity: ${item.quantity}`, 60, yPos);
      doc.text(`Price: K${item.item_price}`, 120, yPos);

      yPos += 10;
    });

    // Shipping Address
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(40, 40, 40);
    doc.text("DELIVERY ADDRESS:", 15, yPos);
    yPos += 10;

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(80, 80, 80);
    if (order.deliveryMode === "pickup") {
      doc.text(order.delivery_info?.store, 20, yPos);
      yPos += 8;
    } else {
      doc.text(order.delivery_info?.zone, 20, yPos);
      yPos += 8;
      doc.text(order.delivery_info?.street, 20, yPos);
    }

    // Total amount
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 100, 0); // Green color
    doc.text(`TOTAL AMOUNT: K${order.total}`, 15, yPos);

    // Footer
    doc.setFontSize(10);
    doc.setTextColor(150, 150, 150);
    doc.text("Thank you for your purchase!", 105, 280, { align: "center" });

    // Save PDF
    doc.save(`receipt-${order.id}.pdf`);
  };

  return (
    <div>
      <PageTitle title="My Order" />
      <div className="order-container">
        <div className="order-card">
          <div className="order-header">
            <div className="order-title">
              <h2>Order #{order.id}</h2>
              <span>{order.payment_reference}</span>
              <p className="order-date">
                <CiCalendar size="25" /> Placed on{" "}
                {formatDate(order.order_date)}
              </p>
            </div>
            <div className="status-container">
              <div className="status-indicator">
                {getStatusIcon(order.order_status)}
                <span className="status-text">
                  {order.order_status.replace("-", " ")}
                </span>
              </div>
              <button onClick={generatePDF} className="download-button">
                <FiDownload className="download-icon" />
                Download Receipt
              </button>
            </div>
          </div>

          <div className="order-content">
            {/* Order Items */}
            <div className="order-items">
              <h3>Items</h3>
              {orderItems.map((item) => (
                <div key={item.id} className="order-item">
                  <img
                    src={
                      typeof item.item_img === "string" && item.item_img
                        ? item.item_img
                        : "/placeholder-image.jpg"
                    }
                    alt={item.item_name || "Unnamed Item"}
                    className="item-image"
                  />
                  <div className="item-details">
                    <h4>{item.name}</h4>
                    <p>Quantity: {item.quantity}</p>
                  </div>
                  <div className="item-price">
                    <p>K{item.item_price}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Shipping Details */}
            <div className="shipping-details">
              <h3>
                {order?.deliveryMode === "pickup"
                  ? "Pickup Store"
                  : "Delivery Address"}
              </h3>

              {order?.deliveryMode === "pickup" ? (
                <>
                  <p>{order.delivery_info?.store}</p>
                  {StoresUrl.find(
                    (store) => store[order.delivery_info?.store]
                  ) ? (
                    <a
                      href={
                        StoresUrl.find(
                          (store) => store[order.delivery_info?.store]
                        )[order.delivery_info?.store]
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="google-maps-link"
                    >
                      <CiMap size={25} className="google-maps-icon" />
                      Open in Google Maps
                    </a>
                  ) : (
                    <p>Store location not available</p>
                  )}
                </>
              ) : (
                <>
                  <p>{order.delivery_info?.zone}</p>
                  <p>{order.delivery_info?.street}</p>
                </>
              )}
            </div>

            {/* Order Summary */}
            <div className="order-summary">
              <div className="total-amount">
                <h3>Total Amount</h3>
                <p>K{order.total.toFixed(2)}</p>
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          .order-container {
            max-width: 800px;
            margin: 0 auto;
            padding: 2rem;
          }

          .order-card {
            background: white;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            border: 1px solid #e5e7eb;
          }

          .order-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1.5rem;
            border-bottom: 1px solid #e5e7eb;
          }

          .order-title h2 {
            font-size: 1.25rem;
            margin: 0;
          }

          .order-date {
            color: #6b7280;
            font-size: 0.875rem;
            margin: 0.25rem 0 0;
          }

          .status-container {
            display: flex;
            align-items: center;
            gap: 1rem;
          }

          .status-indicator {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .status-icon {
            width: 1.25rem;
            height: 1.25rem;
          }

          .status-text {
            text-transform: capitalize;
          }

          .blue {
            color: #3b82f6;
          }
          .green {
            color: #10b981;
          }
          .yellow {
            color: #f59e0b;
          }
          .gray {
            color: #6b7280;
          }

          .download-button {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.5rem 1rem;
            background: white;
            border: 1px solid #e5e7eb;
            border-radius: 4px;
            cursor: pointer;
            transition: background 0.2s;
          }

          .download-button:hover {
            background: #f3f4f6;
          }

          .order-content {
            padding: 1.5rem;
          }

          .order-items {
            margin-bottom: 2rem;
          }

          .order-item {
            display: flex;
            align-items: center;
            gap: 1rem;
            padding: 1rem 0;
            border-bottom: 1px solid #e5e7eb;
          }

          .item-image {
            width: 80px;
            height: 80px;
            object-fit: cover;
            border-radius: 4px;
          }

          .item-details {
            flex: 1;
          }

          .item-details h4 {
            margin: 0 0 0.25rem;
          }

          .item-price {
            font-weight: 500;
          }

          .shipping-details {
            margin: 2rem 0;
          }

          .order-summary {
            border-top: 1px solid #e5e7eb;
            padding-top: 1.5rem;
          }

          .total-amount {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0.5rem;
          }

          .delivery-date {
            color: #6b7280;
            font-size: 0.875rem;
          }
          .google-maps-link {
            align-items: center;
            gap: 0.5rem;
            color: #3b82f6;
            text-decoration: none;
            font-weight: 500;
            margin-top: 0.5rem;
          }

          .google-maps-link:hover {
            text-decoration: underline;
          }

          .google-maps-icon {
            color: #3b82f6;
          }
        `}</style>
      </div>
    </div>
  );
};

export default MyOrder;
